export type DevicePlatform = 'ios' | 'android' | 'desktop';

/** Detect user's platform from userAgent (handles iPad on iOS 13+). */
export function detectPlatform(): DevicePlatform {
  if (typeof navigator === 'undefined') return 'desktop';

  const ua = navigator.userAgent;

  // iPhone / iPod / iPad (classic UA)
  if (/iPhone|iPod|iPad/.test(ua)) return 'ios';

  // iPad on iOS 13+ reports as Mac with touch support
  if (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) return 'ios';

  if (/Android/.test(ua)) return 'android';

  return 'desktop';
}
